import { useCurrencyState } from '../../stores/subscriptionSelectors';
import { CurrencyCode } from '../../types/api';
import { DollarSign, Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface CurrencySelectorProps {
  className?: string;
}

export default function CurrencySelector({ className = '' }: CurrencySelectorProps) {
  const { t } = useTranslation();
  const { currency, availableCurrencies, setCurrency } = useCurrencyState();
  
  const handleCurrencyChange = (newCurrency: CurrencyCode) => {
    setCurrency(newCurrency);
  };
  
  return (
    <div className={`${className}`}>
      <div className="text-sm text-gray-500 mb-3">{t('components.currencySelector.selectCurrency')}</div>
      
      <div className="flex space-x-3">
        {availableCurrencies.map((curr) => (
          <div 
            key={curr.code}
            className={`border-2 rounded-lg transition-colors cursor-pointer flex-1 ${
              currency === curr.code 
                ? 'border-[#F9D348] bg-[#FFF9E6]' 
                : 'border-gray-200 hover:border-gray-300'
            }`}
            onClick={() => handleCurrencyChange(curr.code)}
          >
            <div className="p-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${
                    currency === curr.code ? 'border-[#F9D348]' : 'border-gray-300'
                  }`}>
                    {currency === curr.code && (
                      <div className="w-3 h-3 rounded-full bg-[#F9D348]"></div>
                    )}
                  </div>
                  <div className="ml-2">
                    <div className="flex items-center">
                      <span className="text-base font-medium">{curr.name}</span>
                    </div>
                    <p className="text-sm text-gray-500 mt-1">
                      {curr.symbol} {curr.code.toUpperCase()}
                    </p>
                  </div>
                </div>
                {currency === curr.code && (
                  <Check size={20} className="text-green-500" />
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
} 